import { render, staticRenderFns } from "./appDialog.vue?vue&type=template&id=63b6d56a&scoped=true"
import script from "./appDialog.vue?vue&type=script&lang=js"
export * from "./appDialog.vue?vue&type=script&lang=js"
import style0 from "./appDialog.vue?vue&type=style&index=0&id=63b6d56a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b6d56a",
  null
  
)

export default component.exports